import styled from '@emotion/styled';

export const Content = styled.div`
    @media screen {
        padding: 80px 150px;
        .mb-4 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 32px;
            line-height: 37px;
            text-align: center;
            padding-bottom : 30px;
        }
        .mb-5 {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 28px;
            line-height: 37px;
            text-align: left;
        }
        p {
            font-family: Source Sans Pro;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            line-height: 24px;
        }

        .btn-primary {
            margin-top : 20px;
        }

        .container-dropzone {

        }

        .logo {
            background-color: white;
        }

        .searchBar{
            min-height: 70px;
        }
       

        .dropzone {
            border: 1px dashed black;
            background-color : white;
            height : 150px;
            margin-bottom : 50px;
        }

        .searchLogo{
            height: 25px;
        }

        .text-center{
            text-align: center;
        }

        .previewObject{
            height : 200px;
        }

        .cardMahasiswa{
            width: 350px;
            float: none;
            margin: 0 auto;
        }

        .textHeader{
            font-size:25px;
        }

        .bgStatus{
            width: 200px;
            float: none;
            margin: 0 auto;
            background-color: #FFBDBD;
            border-radius: 25px;
        }

        .bgStatusSukses{
            width: 200px;
            float: none;
            margin: 0 auto;
            background-color: #CBFFE5;
            border-radius: 25px;
        }

        .textStatus{
            font-size:20px;
            padding-top: 10px;
            padding-bottom: 10px;
            color: #AF0000;
        }

        .textStatusSukses{
            font-size:20px;
            padding-top: 10px;
            padding-bottom: 10px;
            color: #0A8C7C;
        }

        .text-danger{
            text-align: right!important;
        }

        .listKum{
            margin-top: 80px;
        }

        background-color : #F7F7F7;

        min-height: 100vh;
            
        `;
